import { render, staticRenderFns } from "./imageMarkWrapperforDeceted.vue?vue&type=template&id=a1a7e6ca&scoped=true&"
import script from "./imageMarkWrapperforDeceted.vue?vue&type=script&lang=js&"
export * from "./imageMarkWrapperforDeceted.vue?vue&type=script&lang=js&"
import style0 from "./imageMarkWrapperforDeceted.vue?vue&type=style&index=0&id=a1a7e6ca&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a1a7e6ca",
  null
  
)

export default component.exports